import AuthBase from "../../AuthBase";
import {Avatar, Stack, useTheme} from "@mui/material";
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import {useContext, useRef, useState} from "react";
import Typography from "@mui/material/Typography";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfigContext from "../../../context/ConfigContext";
import DinoDialog from "../../../components/Dialog";
import Button from "@mui/material/Button";
import CircleButton from "../../../components/CircleButton";
import {useNavigate, useParams, useLocation} from "react-router";
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import * as React from "react";
import Box from "@mui/material/Box";
import ServiceData from "./components/ServiceData";
import Loading from "../../../components/Loading";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import NoItems from "../../../components/NoItems";
import useServiceQueries from "../../../hooks/queries/useServiceQueries";
import useCategoryQueries from "../../../hooks/queries/useCategoryQueries";
import {useSnackbar} from "notistack";
import BlurhashAvatar from "../../../components/BlurhashAvatar";


const Service = ({id, name, visible, description, image, imageBlurhash, edit, destroy}) => {
    const theme = useTheme()

    return <Stack sx={{flexDirection: {xs: 'column', sm: 'column', md: 'row'}}} spacing={2}
                  style={{width: '100%', justifyContent: 'space-between'}}>
        <Stack direction='row' spacing={2}>
            <BlurhashAvatar
                src={image}
                blurhash={imageBlurhash}
                size={60}
                sx={{
                    border: "2px solid",
                    borderColor: theme.palette.primary[200],
                    alignSelf: "center",
                }}
            />
            <Box sx={{alignSelf: 'center'}}>
                <Typography variant="subtitle1" style={{color: theme.palette.primary[600]}}>{name}</Typography>
                <Typography variant="body2" flexWrap style={{color: '#536B74'}}>{description}</Typography>
            </Box>
        </Stack>

        <Stack style={{alignSelf: 'center'}} spacing={1} direction='row'
               sx={{display: {xs: 'none', sm: 'none', md: 'flex'}}}>
            <Typography variant='button' align='center' noWrap
                        style={{color: visible ? theme.palette.primary[600] : '#6F8E9A', alignSelf: 'center',}}>
                {visible ? <Box sx={{display: 'flex'}}><RemoveRedEyeRoundedIcon
                        sx={{alignSelf: 'center', marginRight: 1}}/><Typography sx={{alignSelf: 'center'}}
                                                                                variant='caption'>látható</Typography></Box> :
                    <Box sx={{display: 'flex'}}><VisibilityOffRoundedIcon sx={{alignSelf: 'center'}}/> <Typography
                        sx={{alignSelf: 'center'}} variant='caption'>rejtett</Typography></Box>}
            </Typography>
            <CircleButton icon={<DeleteIcon/>} onClick={destroy}/>
            <CircleButton icon={<EditIcon/>} onClick={edit} inverted/>
        </Stack>

        <Stack spacing={1} sx={{display: {xs: 'flex', sm: 'flex', md: 'none'}}}>
            <Typography variant='button' align='center' noWrap
                        style={{color: visible ? theme.palette.primary[600] : '#6F8E9A', alignSelf: 'center',}}>
                {visible ? <Box sx={{display: 'flex'}}><RemoveRedEyeRoundedIcon sx={{alignSelf: 'center'}}/><Typography
                        sx={{alignSelf: 'center'}} variant='caption'>látható</Typography></Box> :
                    <Box sx={{display: 'flex'}}><VisibilityOffRoundedIcon sx={{alignSelf: 'center'}}/> <Typography
                        sx={{alignSelf: 'center'}} variant='caption'>rejtett</Typography></Box>}
            </Typography>
            <Button variant='outlined' endIcon={<DeleteIcon/>} onClick={destroy}>Törlés</Button>
            <Button variant='contained' endIcon={<EditIcon/>} onClick={edit}>Szerkesztés</Button>
        </Stack>
    </Stack>
}


const Services = () => {
    const [current, setCurrent] = useState(1)
    const [newOpen, setNewOpen] = useState(false)
    const [deleteOpen, setDeleteOpen] = useState(false)

    const serviceForm = useRef(null)
    const params = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const {baseUrl} = useContext(ConfigContext)
    const {useServiceCategoryQuery, createServiceMutation, deleteServiceMutation} = useServiceQueries()
    const {useCategoryDetailQuery} = useCategoryQueries()
    const {enqueueSnackbar} = useSnackbar()

    const {data: services, isPending: servicesLoading} = useServiceCategoryQuery(params.categoryId)
    const {data: category, isPending: categoryLoading} = useCategoryDetailQuery(params.categoryId)

    const findService = id => services.find(c => c.id === id)

    const newService = data => createServiceMutation.mutate({...data, category: category.id}, {
        onSuccess: response => navigate(location.pathname + `/${response.id}`),
        onError: errors => {
            errors.errors.forEach(err => {
                if (err.field) {
                    enqueueSnackbar(`${err.message} - ${err.field}`, {variant: 'error'});
                } else {
                    enqueueSnackbar(err.message, {variant: 'error'});
                }
            });
        }
    })

    const removeService = id => deleteServiceMutation.mutate(id)

    const buttons = [{
        name: 'Új szolgáltatás hozzáadása',
        props: {
            variant: 'contained',
            size: 'large',
            endIcon: <AddCircleOutlinedIcon/>,
            onClick: () => {
                setNewOpen(true)
            }
        }
    }]

    const filterButtonsMobile = [
        {
            name: 'Új szolgáltatás',
            props: {
                variant: 'contained',
                size: 'small',
                endIcon: <AddCircleOutlinedIcon/>,
                onClick: () => {
                    setNewOpen(true)
                }
            }
        }
    ]

    if (servicesLoading || categoryLoading || deleteServiceMutation.isPending || createServiceMutation.isPending) return <Loading isLoading />

    return <AuthBase label={category?.name} buttons={buttons} filterButtonsMobile={filterButtonsMobile}>
        <div className="main">
            <Button
                variant='text'
                startIcon={<ArrowBackIosNewRoundedIcon/>}
                onClick={() => navigate(`/categories`)}
            >
                vissza
            </Button>
            {services.length === 0 ? <NoItems
                    title='Nincsenek szolgáltatások'
                    description='Adj hozzá új szolgáltatást a fenti gombra kattintva! 👆'
                /> :
                <Stack>
                    <Typography
                        variant='subtitle2'
                        color='#536B74'
                        gutterBottom
                    >
                        {services.length} szolgáltatás
                    </Typography>
                    <div className="white-card">
                        {services.map((s, i) =>
                            <Service
                                key={`service_${i}`}
                                name={s.name}
                                description={s.description}
                                visible={s.is_public}
                                image={s.image.startsWith('http') ? s.image : baseUrl + s.image}
                                imageBlurhash={s.blurhash}
                                numberOfServices={s.number_of_services}
                                edit={() => navigate(location.pathname + `/${s.id}`)}
                                destroy={() => {
                                    setCurrent(s.id)
                                    setDeleteOpen(true)
                                }}
                            />
                        )}
                    </div>
                </Stack>}
        </div>

        <DinoDialog
            open={newOpen}
            title='Új szolgáltatás hozzáadása'
            subtitle='Add meg a szolgáltatás nevét és leírását!'
            actions={<>
                <Button variant='outlined' style={{padding: 15}} onClick={() => setNewOpen(false)}>Mégsem</Button>
                <Button variant='contained' style={{padding: 15}} onClick={() => {
                    const data = serviceForm.current.getData()
                    if (!data) return
                    if (Object.keys(data).length > 0) {
                        newService(data)
                        setNewOpen(false)
                    }
                }} endIcon={<AddCircleOutlinedIcon/>}>Hozzáadás</Button>
            </>}
            handleClose={() => setNewOpen(false)}
        >
            <ServiceData reference={serviceForm}/>
        </DinoDialog>

        <DinoDialog
            open={deleteOpen}
            title={`Biztosan kitörli ezt: ${findService(current)?.name}`}
            subtitle='Az összes hozzá tartozó adat törlődni fog, foglalások, árak...!'
            actions={<>
                <Button variant='outlined' style={{padding: 15}} onClick={() => setDeleteOpen(false)}>Mégsem</Button>
                <Button variant='contained' style={{padding: 15}} onClick={() => {
                    setDeleteOpen(false)
                    removeService(current)
                }} endIcon={<DeleteRoundedIcon/>}>Törlés</Button>
            </>}
            handleClose={() => setDeleteOpen(false)}
        />

    </AuthBase>
}

export default Services